module.exports = __webpack_public_path__ + "static/4-63a44833b253ae2681473a9cab886ee2.jpeg";